import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState } from 'react';
import MinRatingRadio from 'components/MinRatingRadio';
import FilterDropdown from 'components/FilterDropdown';
export var DEFAULT_TITLE = 'Min rating';
var RatingDropdown = function (_a) {
    var defaultValue = _a.defaultValue, onSave = _a.onSave, _b = _a.dataTest, dataTest = _b === void 0 ? 'RatingDropdown' : _b;
    var _c = useState(defaultValue ? "".concat(DEFAULT_TITLE, ": ").concat(defaultValue) : DEFAULT_TITLE), title = _c[0], setTitle = _c[1];
    var _d = useState(defaultValue), value = _d[0], setValue = _d[1];
    var onResetTypes = function () {
        setTitle(DEFAULT_TITLE);
        setValue(undefined);
        onSave(undefined);
    };
    var onSaveRating = function () {
        setTitle(value ? "".concat(DEFAULT_TITLE, ": ").concat(value) : DEFAULT_TITLE);
        onSave(value);
    };
    var content = (_jsx(MinRatingRadio, { onChange: function (e) {
            return setValue(e.target.value);
        }, value: value }));
    return (_jsx(FilterDropdown, { title: title, content: content, onSave: onSaveRating, onReset: onResetTypes, dataTest: dataTest }));
};
export default RatingDropdown;
